var SwiperFormations = {
    init:function(){
        var swiper = new Swiper(".akrolab-slider-formations .swiper-container", {
            slidesPerView:'auto',
            spaceBetween: 20,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
              },
              breakpoints: {
                  
                  1040: {
                      spaceBetween: 45,
                  }
                }
          });
    }
}

$(window).load(function(){
    if($('.akrolab-slider-formations').length){
        SwiperFormations.init();
    }
})